<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

const props = withDefaults(defineProps<{
  class?: HTMLAttributes['class']
  size?: 'sm' | 'md' | 'lg'
}>(), {
  size: 'md',
})
</script>

<template>
  <div
    :class="cn(
      'block-title font-semibold text-ink-2',
      props.size === 'sm' && 'text-xs uppercase tracking-wider text-ink-5 mb-2',
      props.size === 'md' && 'text-lg font-bold mb-3',
      props.size === 'lg' && 'text-xl font-bold mb-4',
      props.class,
    )"
  >
    <slot />
  </div>
</template>
